import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Config } from '../../features/chat/interfaces/config.interface';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({
    providedIn: 'root',
})
export class ConfigService {
    private httpClient = inject(HttpClient);

    // Get config as an client (access to less infos as admin)
    public getClientConfig(clientId: string): Observable<Config> {
        return this.httpClient.get<Config>(environment.api + 'config/' + clientId);
    }

    // Get config as an admin (access to more infos)
    public getAdminConfig(): Observable<Config> {
        return this.httpClient.get<Config>(environment.api + 'admin/config');
    }

    public updateConfig(config: Config): Observable<Config> {
        return this.httpClient.put<Config>(environment.api + 'admin/config', config);
    }

    public getContext(): Observable<{ persistentContext: string }> {
        return this.httpClient.get<{ persistentContext: string }>(environment.api + 'admin/persistent-context');
    }

    public updateContext(newContext: string): Observable<{ persistentContext: string }> {
        return this.httpClient.put<{ persistentContext: string }>(environment.api + 'admin/persistent-context', {
            persistentContext: newContext,
        });
    }
}
